import { useState, useEffect } from 'react';

function useBillingPreview (props) {
    const {
        getAddOns,
        billingStore,
        setPricingSummary,
        pricingSummary,
        input,
        addOnsValues,
        chargifyInput,
    } = props;

    const [showPromoCode, setShowPromoCode] = useState(false);
    const [previewIsLoading, setPreviewIsLoading] = useState(false);
    const [promoCode, setPromoCode] = useState('');
    const [promoCodeValid, setPromoCodeValid] = useState(true);
    const [promoCodeValidated, setPromoCodeValidated] = useState(false);
    const [promoCodeBtnLabel, setPromoCodeBtnLabel] = useState('Apply');
    const [promoCodeBtnDisabled, setPromoCodeBtnDisabled] = useState(true);
    const [promoCodeHelperText, setPromoCodeHelperText] = useState('');
    const [promoCodeTouched, setPromoCodeTouched] = useState(false);

    function toDefaultSettings () {
        setShowPromoCode(false);
        setPreviewIsLoading(false);
        setPromoCode('');
        setPromoCodeValid(true);
        setPromoCodeValidated(false);
        setPromoCodeBtnLabel('Apply');
        setPromoCodeBtnDisabled(true);
        setPromoCodeHelperText('');
        setPromoCodeTouched(false);
        billingStore.coupon = '';
        billingStore.previewFromClick = false;
    }

    function validatePromoCode () {
        if (billingStore.previewFromClick) {
            billingStore.previewFromClick = false;
            billingStore.promoCodeValidated = true;
            setPromoCodeValidated(true);
        }
    }

    function previewSubscription () {
        if (billingStore.coupon) {
            setPromoCode(billingStore.coupon);
        }
        getSubscriptionPreview();
    }

    async function getSubscriptionPreview () {
        if (billingStore.isScreenTransition) {
            billingStore.isScreenTransition = false;
        } else {
              // only show preview loading on when it's in the form
            setPreviewIsLoading(true);
        }

        const newAddOns = getAddOns(addOnsValues, input);
        const previewParams = {
            code: input.code,
            addOns: newAddOns,
            chargifyInput,
        };

        console.log('useBillingPreview().getSubscriptionPreview() -> will get subscription preview promoCode: ', billingStore.coupon);
        await billingStore.getSubscriptionPreview(previewParams);
        setPreviewIsLoading(false);
        const newPricingSummary = billingStore.overridePricingSummary(pricingSummary);
        if (promoCodeTouched || promoCodeValidated) {
            validateStates();
        }
        setPricingSummary(newPricingSummary);
    }

    function validateStates () {
        console.log('');
        console.log('');
        console.log('useBillingPreview().validateStates() ....');
        const couponValid = billingStore.isCouponValid();

        console.log('validateStates() couponValid: ', couponValid);
        setPromoCodeValid(couponValid);
        setPromoCodeBtnDisabled(true);

        if (!couponValid) {
            setPromoCode('');
            billingStore.coupon = '';
            setPromoCodeBtnLabel('Apply');
            setPromoCodeValidated(false);
            billingStore.promoCodeValidated = false;
            setPromoCodeHelperText('Promo code invalid.');
        } else {
            setPromoCodeValidated(true);
            billingStore.promoCodeValidated = true;
            setPromoCodeBtnLabel('Applied');
            setPromoCodeHelperText('Promo code applied!')
        }
    }

    function updatePromoCode (value) {
        setPromoCode(value);
        if (value) {
            setPromoCodeTouched(true);
            setPromoCodeBtnDisabled(false);
        } else {
            setPromoCodeBtnDisabled(true);
        }
        billingStore.coupon = value;
    }

    function cleanPromoCode () {
        if (!promoCodeValid || promoCodeHelperText === '') {
            billingStore.coupon = '';
        }
    }

    function revalidatePreview (data) {
        /* Retrieve new preview on address changes */
        clearTimeout(billingStore.previewSubscriptionTO);
        if (!data) return;
        if (data.city ||
            data.country ||
            data.zip ||
            data.address) {
                billingStore.previewSubscriptionTO = setTimeout(() => previewSubscription(), 400);
        }
    }

    useEffect(() => {
        return () => {
            cleanPromoCode();
            toDefaultSettings();
            billingStore.promoCodeValidated = false;
        }
    }, []);

    return {
        promoCode,
        promoCodeValid,
        promoCodeBtnLabel,
        promoCodeBtnDisabled,
        promoCodeHelperText,
        previewIsLoading,
        previewSubscription,
        updatePromoCode,
        showPromoCode,
        setShowPromoCode,
        cleanPromoCode,
        promoCodeValidated,
        validatePromoCode,
        revalidatePreview,
    }
}

export default useBillingPreview;
